var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhoneAndroid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11 0H3a3 3 0 00-3 3v16a3 3 0 003 3h8a3 3 0 003-3V3a3 3 0 00-3-3zM9 20H5v-1h4zm3.25-3H1.75V3h10.5z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNCAyMiI+CiAgICA8cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGQ9Ik0xNiwxSDhBMywzLDAsMCwwLDUsNFYyMGEzLDMsMCwwLDAsMywzaDhhMywzLDAsMCwwLDMtM1Y0QTMsMywwLDAsMCwxNiwxWk0xNCwyMUgxMFYyMGg0Wm0zLjI1LTNINi43NVY0aDEwLjVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNSAtMSkiLz48L3N2Zz4=";
export { SvgPhoneAndroid as ReactComponent };